import React, { useEffect, useRef, useState } from 'react';
import { Section } from '../Section';
import { Heading2 } from '../Heading2';
import { FadeUp } from '../FadeUp';
import { faqItems } from '../../data/faq';
function FaqRow({
  question,
  answer,
  open,
  onToggle,
  isFirst
}: {
  question: string;
  answer: string;
  open: boolean;
  onToggle: () => void;
  isFirst: boolean;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const measure = () => setHeight(contentRef.current?.scrollHeight ?? 0);
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [answer]);
  return <div style={isFirst ? undefined : {
    borderTop: '1px solid rgba(20,17,15,.12)'
  }} data-id="element-129" data-mp="1l0pk4pkgcx5r">
      <button type="button" onClick={onToggle} aria-expanded={open} className="flex w-full items-center justify-between gap-4 py-[18px] text-left" data-id="element-130" data-mp="28rboo6v8zzb0">
        <span className="text-[16px] font-extrabold" data-id="element-131" data-mp="2oq8ms7rjhl4b">{question}</span>
        <span aria-hidden="true" className="flex-none text-[20px] font-extrabold leading-none transition-transform duration-300 ease-out" style={{
        transform: open ? 'rotate(45deg)' : 'rotate(0deg)'
      }} data-id="element-132" data-mp="2oqieq0w5a2cn">
          +
        </span>
      </button>
      <div className="overflow-hidden transition-[max-height] duration-300 ease-out" style={{
      maxHeight: open ? `${height}px` : '0px'
    }} data-id="element-133" data-mp="2tnqw3z9gy2cu">
        <div ref={contentRef} data-id="element-134" data-mp="32i5a7yi9j6ud">
          <p className="pb-[18px] pr-8 text-[15px] leading-[1.65] text-ink/75" data-id="element-135" data-mp="32gu8034gu75d">{answer}</p>
        </div>
      </div>
    </div>;
}
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section data-id="element-136" data-mp="3cdyuk42844mp">
      <FadeUp data-id="element-137" data-mp="1n0v9ljknhpib">
        <Heading2 data-id="element-138" data-mp="1n0d8o9n1mn42">Questions before you get started</Heading2>

        <div className="mt-10" data-id="element-139" data-mp="1n2zheclo78nv">
          {faqItems.map((item, index) => <FaqRow key={item.question} question={item.question} answer={item.answer} open={openIndex === index} isFirst={index === 0} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-140" data-mp="1i3d27xma7icf" data-mpi={index} />)}
        </div>
      </FadeUp>
    </Section>;
}